


















































































































































import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { RootStoreState } from '../../../../store/store';
import RecaptchaComponent from './../../../../shared/captchaComponent/RecaptchaComponent.vue';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SetTFAModePayload } from '../../../core.store';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';
@Component({
  components: {
    SwIcon,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwCheckbox,
    RecaptchaComponent,
  },
})
export default class SwTfaDialog extends SwExtendedVue {
  @Prop(String)
  tfaMedium: string;
  @Prop()
  value: any;
  @Prop()
  email: any;
  @Prop()
  showRememberMe: Boolean;
  @Prop()
  isCaptchaNeeded: boolean;
  @Prop()
  showTFADialog: Boolean;
  @State((state: RootStoreState) => state.CoreStoreModule.tfaMode)
  readonly tfaMode:boolean;

  @Mutation
  setTfaMode: VuexMappedMutation<SetTFAModePayload>;

  captchaResponse: string = '';

  emailCodeClicked: boolean = false;
  tfaCode: string = '';
  tfaCodeError: boolean = false;
  maskedInputType: string = 'password';
  showInputError: boolean = false;
  errorMessage: string = '';
  rememberMeValue: boolean = false;
  emailTFACode() {
    this.emailCodeClicked = true;
    this.tfaCode = '';
    this.tfaCodeError = false;
    this.setTfaMode({ mode: 'EMAIL' });
    const obj = {
      username: this.$store.getters.getUserId,
      authmode: this.tfaMode,
      password: this.value.password,
      clientId: this.$store.getters.getClientId,
    };
    this.$store.dispatch('sendEmail', obj)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          messageService.messageManager.showMessage('login-message',  res.msgDesc , 'success');
          if (res.content && res.content.TFAID) {
            localStorage.setItem('TFAID', res.content.TFAID.toString());
          }
        } else {
          messageService.messageManager.showMessage('login-message',  res.msgDesc , 'failed');
        }
      });
  }
  resendTFACode() {
    this.tfaCodeError = false;
    this.tfaCode = '';
    this.$emit('resendToken');
  }
  verifyTFA() {
    if (this.isCaptchaNeeded) {
      let result: { status: string; response: string; msg: string; } = { status: '', response: '', msg: '' };
      result = (this.$refs['recaptchaComponent'] as RecaptchaComponent)?.fetchCaptcha() || { status: '', response: '', msg: '' };
      if (result && result.status === 'error') {
        messageService.messageManager.showMessage('login-message',  result?.msg , 'failed');
        return;
      }
      this.captchaResponse = result.response ? result.response : '';
    } else {
      this.captchaResponse = '';
    }
    if (this.tfaCode === '') {
      this.tfaCodeError = true;
    } else {
      const TFAID: any = localStorage.getItem('TFAID');
      const obj = {
        username: this.$store.getters.getUserId,
        authmode: this.tfaMode,
        password: this.value.password,
        clientId: this.$store.getters.getClientId,
        authkey: this.tfaCode.trim(),
        TFACode: this.tfaCode.trim(),
        captchaText: this.captchaResponse ? this.captchaResponse : '',
        rememberMe: this.rememberMeValue ? 'TRUE' : 'FALSE',
        TFAID: TFAID ? TFAID : '',
      };
      this.$store.dispatch('verifyTFA', obj)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'NOK') {
            messageService.messageManager.showMessage('login-message', res.msgDesc, 'failed');
          }
          if (res.operationStatus === 'OK') {
            if (res.content.deviceCode && res.content.deviceCode !== null) {
              this.setCookie('dcode', res.content.deviceCode);
            }
            this.$store.dispatch('preserveUserInfo', res);
            this.goToDashboard();
          }
        })
        .catch((error: any) => {
          messageService.messageManager.showMessage('login-message', error.message, 'failed');
        });
    }
  }
  showError(msg: any) {
    this.showInputError = true;
    this.errorMessage = msg;
    setTimeout(() => { this.showInputError = false; this.errorMessage = ''; }, 3000);
  }
  setCookie(cookieKey: any, cookieValue: any) {
    this.removeCookie(cookieKey)
    .then(() => {
      document.cookie = `${cookieKey}=${cookieValue}`;
    });
  }
  removeCookie(cookieKey: any) {
    return new Promise((resolve: any, reject: any) => {
      console.warn(reject);
      document.cookie = `${cookieKey}=`;
      resolve(true);
    });
  }
  closeDialog() {
    this.captchaResponse = '';
    this.tfaCode = '';
    this.$emit('closeTFADialog');
  }
  goToDashboard() {
    console.warn('dummy log');
    const TFAID: any = localStorage.getItem('TFAID');
    if (TFAID) {
      localStorage.removeItem('TFAID');
    }
    this.$router.push({ path:'/m/feature/spog-homepage' });
  }
  mounted() {
    const inputEl = this.$refs.tfaCode as HTMLElement;
    if (inputEl) { inputEl.focus(); }
  }
}
